// @flow

import React from "react"
import { useIntl } from "react-intl"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { PrimaryButton } from "@cabonline/shared/components"
import { TitlePrimary } from "../../../shared/components/text"
import analytics from "shared/utils/services/analytics"
import { ACTIONS } from "shared/constants/gaEvents"

const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  background: white;
  padding: 12px;
  padding-top: 35px;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 340px;
`

const TitleWrapper = styled.div`
  padding-bottom: 24px;
`

const DescriptionWrapper = styled.div`
  padding-bottom: 20px;
  white-space: initial;
`

type Props = {
  emailAddress: string
}

const AccountAlreadyExist = ({ emailAddress }: Props): React$Element<any> => {
  const Intl = useIntl()
  const continueToLogin = () => {
    analytics.logInteraction(
      ACTIONS.DRIVER_CLICK_CONTINUE_TO_LOGIN,
      "Driver clicked continue to login in account already created page"
    )
  }
  return (
    <Container>
      <ContentWrapper>
        <TitleWrapper>
          <TitlePrimary>
            {Intl.formatMessage({
              id: "apps.driver-web.onboarding.accountalreadycreated.title"
            })}
          </TitlePrimary>
        </TitleWrapper>
        <DescriptionWrapper>
          {Intl.formatMessage({
            id: "apps.driver-web.onboarding.accountalreadycreated"
          })}
          {emailAddress}
        </DescriptionWrapper>
        <Link
          to={{
            pathname: "/",
            state: {
              email: emailAddress
            }
          }}
        >
          <PrimaryButton onClick={continueToLogin}>
            {Intl.formatMessage({
              id: "apps.driver-web.onboarding.continuetologin"
            })}
          </PrimaryButton>
        </Link>
      </ContentWrapper>
    </Container>
  )
}

export default AccountAlreadyExist
